import { refinementList } from 'instantsearch.js/es/widgets'

/**
 * Load the Refinement List widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function refinementListWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-refinement' ) ).forEach(
    element => {
      widgets.push(
        refinementList({
          container: element,
          attribute: element.dataset.attribute,
          operator: element.dataset.operator,
          limit: 15,
          sortBy: refinementSortBy( element.dataset.attribute ),
        })
      )
    })

  return widgets
}

/**
 *
 * @param {String} attribute The searh refinement attribute.
 * @returns {Array} The search refinement sort parameters.
 */
function refinementSortBy( attribute ) {
  const yearSort = ['isRefined:desc', 'name:desc', 'count:desc']
  const typeSort = ['isRefined:desc', 'name:asc', 'count:desc']
  const defaultSort = ['isRefined:desc', 'count:desc', 'name:asc']

  switch ( attribute ) {
    case 'year':
      return yearSort
    case 'type':
      return typeSort
    default:
      return defaultSort
  }
}
